import React, { useState, useEffect } from 'react';
import Nav from './Nav.js';
import "../Styles/Login.css";
import { NavLink, Outlet } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ngosignin, signin, authenticate } from '../API_CALLS/apiHandler.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LinearProgress from '@mui/material/LinearProgress';
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";


function Login() {
    const [isUser, setIsUser] = useState(true);
    const [values, setValues] = useState({
        name: "",
        email: "",
        password: "",
        cpassword: "",
        error: "",
        loading: "",
        success: false
    })

    const [waiting, setWaiting] = useState(false);

    const { name, email, password, cpassword, error, success } = values;
    const history = useNavigate();

    const handleChange = name => event => {
        setValues({ ...values, error: false, [name]: event.target.value })
    }

    const onSignin = event => {
        event.preventDefault();
        setWaiting(true);
        setValues({ ...values, error: false, loading: "" })
        if (!email || !password) {
            toast.error("All fileds must be filled", {
                position: toast.POSITION.TOP_RIGHT, autoClose: 2000
            });
            setWaiting(false);
            return;
        }
        signin({ email, password })
            .then(data => {
                // console.log(data);
                if (data.error) {
                    toast.error(data.error, {
                        position: toast.POSITION.TOP_RIGHT, autoClose: 2000
                    });
                    // setWaiting(false);
                    console.log('hi');

                    setValues({ ...values, error: data.error, loading: "" })
                } else {
                    authenticate(data, () => {
                        setValues({
                            ...values,
                        })
                    })
                    toast.success("You are signed in ", {
                        position: toast.POSITION.TOP_RIGHT, autoClose: 2000
                    });

                    setTimeout(() => { history('/') }, 2000)
                    // console.log('hlo')

                }
                // console.log('hiii');

                setWaiting(false)
            })
            .catch(
                // setWaiting(false),
                // console.log('hiiii')

            )
        // console.log('hello')

    }

    const onNgoSignin = event => {
        event.preventDefault();
        setWaiting(true);

        setValues({ ...values, error: false, loading: "" })

        if (!email || !password) {
            toast.error("All fileds must be filled", {
                position: toast.POSITION.TOP_RIGHT, autoClose: 2000
            });
            setWaiting(false);
            return;
        }
        ngosignin({ email, password })
            .then(data => {
                // console.log(data);
                if (data.error) {
                    toast.error(data.error, {
                        position: toast.POSITION.TOP_RIGHT, autoClose: 2000
                    });


                    setValues({ ...values, error: data.error, loading: "" })
                } else {
                    authenticate(data, () => {
                        setValues({
                            ...values,
                        })
                    })
                    toast.success("You are signed in ", {
                        position: toast.POSITION.TOP_RIGHT, autoClose: 2000
                    });

                    setTimeout(() => { history('/') }, 2000)

                }
                setWaiting(false);
            })
            .catch()
    }

    return (
        <div >
            <Nav />
            <div className="nothing"></div>
            {/* {console.log(waiting)} */}
            <ScrollAnimation duration={2}
                animateIn="animate__fadeInUp">
                <div className="authenticate_form" >
                    <div className="form_header">Login</div>
                    <div className="form_data_select">
                        {isUser ? <> <span className="select_user active" onClick={() => { isUser ? <></> : setIsUser(!isUser) }}>User</span>  <span className="select_ngo " onClick={() => { isUser ? setIsUser(!isUser) : <></> }}>NGO</span></> :
                            <> <span className="select_user" onClick={() => { isUser ? <></> : setIsUser(!isUser) }}>User</span>  <span className="select_ngo active" onClick={() => { isUser ? setIsUser(!isUser) : <></> }}>NGO</span></>}

                    </div>
                    <form className="authenticate_form_field">
                        {isUser ? <>
                            <input type="email" placeholder="Email: user1234@gmail.com" className="textField" value={email} onChange={handleChange("email")} />
                            <br />
                            <br />
                            <input type="password" placeholder="Pass: user1234" className="textField" value={password} onChange={handleChange("password")} />

                            <br /><br />
                        </> : <>
                            <input type="email" placeholder="Email: ngo1234@gmail.com" className="textField" value={email} onChange={handleChange("email")} />
                            <br />
                            <br />
                            <input type="password" placeholder="Pass: ngo1234" className="textField" value={password} onChange={handleChange("password")} />

                            <br /><br />
                        </>}


                        {waiting ? <><LinearProgress color="success" /></> : <>
                            {isUser ? <button className="sign_btn" onClick={onSignin} >Sign In</button> : <button className="sign_btn" onClick={onNgoSignin} >Sign In</button>}
                        </>}





                    </form>
                    <hr />
                    <div className="form_footer">New user? <span className="form_footer_link" > <NavLink style={{ textDecoration: 'none' }} to="/auth/signup"><span className="link">Create Account</span></NavLink></span></div>
                </div>
            </ScrollAnimation>
            <ToastContainer />
            <Outlet />
        </div>
    );
}

export default Login;